import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import { ref, onMounted, watch } from 'vue';
import Api from '@/services/api/ApiServiceFabrick';
import AuthorityCacheApi from "@/services/models/AuthorityCacheApi"
import { useAuth } from "@/services/user/Auth0UserProvider"
import { formatDateTime } from '@/services/functions'
import EditLinkIcon from '@/components/Common/EditLinkIcon.vue'
import DeleteIcon from '@/components/Common/DeleteIcon.vue'
import PaginateWithCount from '@/components/PaginateWithCount.vue'
import getFirmwareBulkUpdateSettingsRequest from '@/types/requests/getFirmwareBulkUpdateSettingsRequest';
import getFirmwareBulkUpdateSettingResponse from '@/types/responses/getFirmwareBulkUpdateSettingResponse';
import { FIRMWARE_BULK_UPDATE_SETTINGS_TABLE_HEADERS } from '@/services/consts/firmware_bulk_update';
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'BulkUpdateList',
  props: {
    showFlash: { type: Function }
  },
  setup(__props: any) {

const { loginWithRedirect } = useAuth();
const bulkUpdateList = ref<getFirmwareBulkUpdateSettingResponse[]>()
const currentPage = ref<number>(1)
const totalPage = ref<number>(1)
const itemsPerPage = ref<number>(15)
const allElementsCount = ref<number>(0)
const isDeleteAuthority = ref<boolean>(false)

const props = __props

onMounted(() => {
  getDeleteAuthority().then((authority) => {
    isDeleteAuthority.value = authority
  })
  getBulkUpdateList()
})

function makeParams() {
  const params = {
    page: currentPage.value
  } as getFirmwareBulkUpdateSettingsRequest

  return params
}

function getBulkUpdateList() {
  const params = makeParams()
  Api().getFirmwareBulkUpdateSettings(params).then((data) => {
    bulkUpdateList.value = data.data
    currentPage.value = data.current_page
    totalPage.value = data.last_page
    allElementsCount.value = data.total
    itemsPerPage.value = data.per_page
    }).catch((error) => {
      const res = error.response
      switch (res.status) {
        case 401:
          loginWithRedirect({ appState: { targetUrl: location.pathname } })
          break
        case 403:
          location.reload()
          break
        default:
          props.showFlash(res.data.message, 'error', true)
          break
      }
    }
  )
}

watch(currentPage, () => {
  getBulkUpdateList()
})

function canDelete(activationDate: string) {
  const now = new Date()
  const activation = new Date(activationDate)
  return activation > now;
}

async function getDeleteAuthority() {
  const authorityList = await AuthorityCacheApi.getWithParse();
  return !!authorityList["octlink.firmware.update"];
}

async function deleteBulkUpdateSetting(id: number) {
  await Api().deleteFirmwareBulkUpdateSetting(id).then(() => {
    props.showFlash(i18n.global.t('pages.common.messages.successDelete'), 'success', true)
    getBulkUpdateList()
  }).catch((error) => {
    const res = error.response
    switch (res.status) {
      case 400:
        props.showFlash(i18n.global.t('pages.accounts.messages.badRequestForDelete'), 'error', true)
        break
      case 403:
        props.showFlash(i18n.global.t('pages.common.messages.forbidden'), 'error', true)
        break
      default:
        props.showFlash(i18n.global.t('pages.common.messages.failedDelete'), 'error', true)
        break
    }
  })
}


return (_ctx: any,_cache: any) => {
  const _component_v_table = _resolveComponent("v-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_table, { class: "mb-2" }, {
      default: _withCtx(() => [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(FIRMWARE_BULK_UPDATE_SETTINGS_TABLE_HEADERS), (column) => {
              return (_openBlock(), _createElementBlock("th", { key: column }, _toDisplayString(column), 1))
            }), 128))
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bulkUpdateList.value, (item) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: item.id
            }, [
              _createElementVNode("td", null, _toDisplayString(item.id), 1),
              _createElementVNode("td", null, _toDisplayString(item.activation_date), 1),
              _createElementVNode("td", null, _toDisplayString(item.firmware?.version), 1),
              _createElementVNode("td", null, _toDisplayString(item.target_device_count), 1),
              _createElementVNode("td", null, _toDisplayString(item.exclusion_device_count), 1),
              _createElementVNode("td", null, _toDisplayString(_unref(formatDateTime)(new Date(item.updated_at))), 1),
              _createElementVNode("td", null, _toDisplayString(item.account?.full_name), 1),
              _createElementVNode("td", null, [
                _createVNode(EditLinkIcon, {
                  name: 'FirmwareBulkUpdateForm',
                  id: item.id
                }, null, 8, ["id"])
              ]),
              _createElementVNode("td", null, [
                (canDelete(item.activation_date))
                  ? (_openBlock(), _createBlock(DeleteIcon, {
                      key: 0,
                      deleteAction: () => deleteBulkUpdateSetting(item.id),
                      isDeleteAuthority: isDeleteAuthority.value,
                      tooltipMessage: _unref(i18n).global.t('pages.firmwareBulkUpdate.tooltip.authority')
                    }, null, 8, ["deleteAction", "isDeleteAuthority", "tooltipMessage"]))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }),
    _createVNode(PaginateWithCount, {
      class: "justify-end",
      totalPage: totalPage.value,
      modelValue: currentPage.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentPage).value = $event)),
      itemsPerPage: itemsPerPage.value,
      allElementsCount: allElementsCount.value,
      showItemCount: true
    }, null, 8, ["totalPage", "modelValue", "itemsPerPage", "allElementsCount"])
  ], 64))
}
}

})